import { useContext, useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import { useGetData } from "../../../../../hooks/useGetData";
import { EvaluadoInterface } from "../../../../../interfaces/EvaluadoInterface";
import { ReporteFinalPresencialInterface } from "../../../../../interfaces/ReporteFinalPresencialInterface";
import { DocumentoPresencialInterface } from "../../../../../interfaces/DocumentoPresencialInterface";
import { SemaforoReportePresencialInterface } from "../../../../../interfaces/SemaforoReportePresencialInterface";
import { FechaReportePresencialInterface } from "../../../../../interfaces/FechaReportePresencialInterface";
import { MotivoEvaluacionPresencialInterface } from "../../../../../interfaces/MotivoEvaluacionPresencialInterface";
import { NotasRfpInterface } from "../../../../../interfaces/NotasRfpInterface";
import { ResultadosRfpInterface } from "../../../../../interfaces/ResultadosRfpInterface";
import { Loading } from "../../../../../components/Loading/Loading";
import { Label, TextInput, Textarea } from "flowbite-react";
import { Button } from "flowbite-react";
import { API } from "../../../../../global/global";
import Semaforo from "../../../../../img/Semaforo.png";
import Rojo from "../../../../../img/Rojo.png";
import Amarillo from "../../../../../img/Amarillo.png";
import Verde from "../../../../../img/Verde.png";
import Header from "../../../../../components/HeaderForms/HeaderForms";
import { ReporteFinalPresencialPrint } from "./ReporteFinalPresencialPrint";
import { ThemeContext } from "../../../../../components/ThemeContext/ThemeContext";
import CertificacionQR from "../../../../../components/CertificacionQR/CertificacionQR";

export const ReporteFinalPresencialListaScreen = () => {
  const {isDarkMode} = useContext(ThemeContext);
  const tituloFormulario = "REPORTE FINAL PRESENCIAL";
  const { control, reset, setValue } = useForm();
  const { evaluadosList_id } = useParams<{ evaluadosList_id: string }>();
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const [images, setImages] = useState<string[]>([""]);
  const [notes, setNotes] = useState<string[]>([]);
  const [fechaNacimiento, setFechaNacimiento] = useState<string>("");
  const [edad, setEdad] = useState<number | null>(null);
  const [photoUrl, setPhotoUrl] = useState<string | null>(null);

  const [formData, setFormData] = useState({
    visitDate: "",
    name: "",
  });

  const calcularEdad = (fechaNacimiento: string) => {
    const fechaNac = new Date(fechaNacimiento);
    const hoy = new Date();
    let edadCalculada = hoy.getFullYear() - fechaNac.getFullYear();
    const mes = hoy.getMonth() - fechaNac.getMonth();

    if (mes < 0 || (mes === 0 && hoy.getDate() < fechaNac.getDate())) {
      edadCalculada--;
    }

    return edadCalculada;
  };

  const handleInputChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    const updatedFormData = { ...formData, [name]: value };
    setFormData(updatedFormData);

    localStorage.setItem("formData", JSON.stringify(updatedFormData));
  };

  const handlePageChange = (newPage: number) => {
    const filledImages = images.filter((image) => image);
    setImages(filledImages.length > 0 ? filledImages : [""]);
    setCurrentPage(newPage);
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    console.log("Datos guardados:", {
      ...formData,
      images,
    });

    navigate(`/modulos_presenciales/${evaluadosList_id}`);
  };

  useEffect(() => {
    const savedFormData = localStorage.getItem("formData");
    const savedZones = localStorage.getItem("selectedZones");
    if (savedFormData) {
      setFormData(JSON.parse(savedFormData));
    }

    const savedImages = localStorage.getItem("images");
    if (savedImages) {
      setImages(JSON.parse(savedImages));
    }
  }, []);

  const renderHeader = () => (
    <>
      {/* Header */}
      <Header titulo={tituloFormulario} />
    </>
  );

  const queryEvaluado = useGetData<EvaluadoInterface>({
    url: `/evaluado/${evaluadosList_id}`,
    name: ["evaluado"],
  });

  const queryReporte = useGetData<{ data: ReporteFinalPresencialInterface }>({
    url: `/reporte-final-presencial/${evaluadosList_id}`,
    name: ["reporte-final-presencial", evaluadosList_id!],
  });

  const queryDocumentos = useGetData<DocumentoPresencialInterface[]>({
    url: `/documentos-presenciales/${evaluadosList_id}`,
    name: ["documentos-presenciales", evaluadosList_id!],
  });

  const querySemaforoRFP = useGetData<SemaforoReportePresencialInterface>({
    url: `/semaforo-reporte-presencial/${evaluadosList_id}`,
    name: ["semaforo-reporte-presencial", evaluadosList_id!],
  });

  const queryFecha = useGetData<FechaReportePresencialInterface>({
    url: `/fecha-reporte-presencial/${evaluadosList_id}`,
    name: ["fecha-reporte-presencial", evaluadosList_id!],
  });

  const queryMotivo = useGetData<MotivoEvaluacionPresencialInterface[]>({
    url: `/motivo-evaluacion-presencial/${evaluadosList_id}`,
    name: ["motivo-evaluacion-presencial", evaluadosList_id!],
  });

  const queryNotasRFP = useGetData<NotasRfpInterface[]>({
    url: `/notas-rfp/${evaluadosList_id}`,
    name: ["notas-rfp", evaluadosList_id!],
  });

  const queryResultadosRFP = useGetData<ResultadosRfpInterface[]>({
    url: `/resultados-rfp/${evaluadosList_id}`,
    name: ["resultados-rfp", evaluadosList_id!],
  });

  const normalizeString = (str: string) => {
    return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  };

  const nombreCompleto = normalizeString(
    `${queryEvaluado.data?.nombre}_${queryEvaluado.data?.apellido_paterno}_${queryEvaluado.data?.apellido_materno}`.replace(
      /\s/g,
      "_"
    )
  );

  const [selectedImage, setSelectedImage] = useState(Semaforo);
  const [selectedRecommendation, setSelectedRecommendation] = useState<
    string | null
  >(null);

  const handleRadioChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    setSelectedRecommendation(value);

    if (value === "recomendable") {
      setSelectedImage(Verde);
    } else if (value === "con_reserva") {
      setSelectedImage(Amarillo);
    } else if (value === "no_recomendable") {
      setSelectedImage(Rojo);
    }
  };

  const handlePrint = () => {
    const printContent = document.getElementById("printableContent");

    if (printContent) {
      const printWindow = window.open("", "", "width=800,height=600");

      if (printWindow) {
        printWindow.document.write(`
              <html>
                <head>
                  <title>Vista Previa de Impresión</title>
                  <style>
                    @media print {
                      body {
                        margin: 20px;
                        font-family: Arial, sans-serif;
                      }
                    }
                  </style>
                </head>
                <body>${printContent.innerHTML}</body>
              </html>
            `);

        const styles = document.styleSheets;
        for (let i = 0; i < styles.length; i++) {
          try {
            if (styles[i].cssRules) {
              const styleTag = printWindow.document.createElement("style");
              for (let j = 0; j < styles[i].cssRules.length; j++) {
                styleTag.appendChild(
                  printWindow.document.createTextNode(
                    styles[i].cssRules[j].cssText
                  )
                );
              }
              printWindow.document.head.appendChild(styleTag);
            }
          } catch (e) {
            console.warn("No se pudo copiar una hoja de estilo:", e);
          }
        }

        printWindow.document.close();
        printWindow.onload = () => {
          setTimeout(() => {
            printWindow.print();
            printWindow.close();
          }, 500);
        };
      } else {
        alert("No se pudo abrir la ventana de impresión.");
      }
    }
  };

  useEffect(() => {
    if (queryEvaluado.data) {
      const fechaNac = queryEvaluado.data.fecha_nacimiento || "";
      setFechaNacimiento(fechaNac);

      const nuevaEdad = calcularEdad(fechaNac);
      console.log("Fecha de nacimiento:", fechaNac);
      console.log("Edad calculada:", nuevaEdad);
      setEdad(nuevaEdad);

      reset({
        nombre: queryEvaluado.data.nombre || "",
        apellido_paterno: queryEvaluado.data.apellido_paterno || "",
        apellido_materno: queryEvaluado.data.apellido_materno || "",
        rfc: queryEvaluado.data.rfc || "",
        genero: queryEvaluado.data.genero || "",
        estado_civil: queryEvaluado.data.estado_civil || "",
        escolaridad: queryEvaluado.data.escolaridad || "",
        fecha_nacimiento: fechaNac,
        curp: queryEvaluado.data.curp || "",
        empresa: queryEvaluado.data.empresa?.nombre || "",
      });
    }
  }, [queryEvaluado.data, reset]);

  useEffect(() => {
    if (evaluadosList_id) {
      const token = localStorage.getItem("token");
      fetch(`${API}/evaluados/${evaluadosList_id}/photo/${nombreCompleto}`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.url) {
            setPhotoUrl(data.url);
            console.log("URL de la foto:", data.url);
          } else {
            setPhotoUrl(null);
          }
        })
        .catch((error) => {
          console.error("Error al obtener la URL de la foto:", error);
          setPhotoUrl(null);
        });
    }
  }, [evaluadosList_id, nombreCompleto]);

  useEffect(() => {
    if (querySemaforoRFP.data) {
      const color = querySemaforoRFP.data.color_semaforo || "";

      let recommendation = "";
      if (color === "verde") {
        recommendation = "recomendable";
      } else if (color === "amarillo") {
        recommendation = "con_reserva";
      } else if (color === "rojo") {
        recommendation = "no_recomendable";
      }

      reset({
        color_semaforo: color,
        evaluado_uuid: querySemaforoRFP.data.evaluado_uuid || "",
      });

      setSelectedRecommendation(recommendation);

      if (recommendation === "recomendable") {
        setSelectedImage(Verde);
      } else if (recommendation === "con_reserva") {
        setSelectedImage(Amarillo);
      } else if (recommendation === "no_recomendable") {
        setSelectedImage(Rojo);
      }
    }
  }, [querySemaforoRFP.data, reset]);

  useEffect(() => {
    console.log("queryMotivo.data:", queryMotivo.data);
    if (queryMotivo.data && queryMotivo.data.length > 0) {
      const motivo = queryMotivo.data[0];
      reset({
        motivo: motivo.motivo || "",
      });
    }
  }, [queryMotivo.data, reset]);

  useEffect(() => {
    console.log("queryNotasRFP.data:", queryNotasRFP.data);
    if (queryNotasRFP.data && queryNotasRFP.data.length > 0) {
      const notas = queryNotasRFP.data[0];
      reset({
        nota_1rfp: notas.nota_1rfp || "",
        nota_2rfp: notas.nota_2rfp || "",
        nota_3rfp: notas.nota_3rfp || "",
        nota_4rfp: notas.nota_4rfp || "",
        nota_5rfp: notas.nota_5rfp || "",
      });
    }
  }, [queryNotasRFP.data, reset]);

  useEffect(() => {
    console.log("queryResultadosRFP.data:", queryResultadosRFP.data);
    if (queryResultadosRFP.data && queryResultadosRFP.data.length > 0) {
      const resultados = queryResultadosRFP.data[0];
      reset({
        resultado_1rfp: resultados.resultado_1rfp || "",
        resultado_2rfp: resultados.resultado_2rfp || "",
        resultado_3rfp: resultados.resultado_3rfp || "",
        resultado_4rfp: resultados.resultado_4rfp || "",
        resultado_5rfp: resultados.resultado_5rfp || "",
      });
    }
  }, [queryResultadosRFP.data, reset]);

  if (queryEvaluado.isLoading) {
    return <Loading />;
  }

  const renderPage1 = () => (
    <div className="space-y-4 p-4">
      <div className="grid grid-cols-3 gap-4">
        {/* Fecha Evaluación */}
        <div className="col-span-1 flex items-center">
          <Label htmlFor="fecha_evaluacione" className="mr-2">
            FECHA EVALUACIÓN:
          </Label>
          <TextInput
            id="fecha_evaluacione"
            type="date"
            value={queryEvaluado.data?.fecha_evaluacione || ""}
            className="text-center w-full"
            disabled={true}
          />
        </div>
        {/* Campo para nombre */}
        <div className="col-span-2">
          <Label htmlFor="nombre">NOMBRE:</Label>
          <TextInput
            id="nombre"
            name="nombre"
            value={`${queryEvaluado.data?.nombre || ""} ${
              queryEvaluado.data?.apellido_paterno || ""
            } ${queryEvaluado.data?.apellido_materno || ""}`}
            onChange={handleInputChange}
            disabled={true}
          />
        </div>

        {/* FOTO */}
        <div className={`w-64 h-64 border rounded-md overflow-hidden flex items-center justify-center mt-4 relative z-10 ${isDarkMode ? "border-gray-600 bg-gray-800" : "border-gray-300 bg-gray-100"}`}>
          {photoUrl ? (
            <img
              src={photoUrl}
              alt="Foto de evaluado"
              className="w-full h-full object-cover"
            />
          ) : (
            <span className={`text-gray-500 ${isDarkMode ? "text-gray-400" : "text-gray-500"}`}>Sin foto disponible</span>
          )}
        </div>
        {/* SEMAFORO */}
        <div className="flex items-center gap-4">
          {/* Radio buttons */}
          <div className="flex flex-col">
            <label className={`flex items-center gap-2 mt-4 mb-4 ${isDarkMode ? "text-gray-200" : "text-gray-900"}`}>
              <input
                type="radio"
                name="recommendation"
                value="recomendable"
                checked={selectedRecommendation === "recomendable"}
                onChange={handleRadioChange}
                disabled={true}
              />
              RECOMENDABLE
            </label>
            <label className={`flex items-center gap-2 mt-12 mb-12 ${isDarkMode ? "text-gray-200" : "text-gray-900"}`}>
              <input
                type="radio"
                name="recommendation"
                value="con_reserva"
                checked={selectedRecommendation === "con_reserva"}
                onChange={handleRadioChange}
                disabled={true}
              />
              CON RESERVA
            </label>
            <label className={`flex items-center gap-2 mb-12 ${isDarkMode ? "text-gray-200" : "text-gray-900"}`}>
              <input
                type="radio"
                name="recommendation"
                value="no_recomendable"
                checked={selectedRecommendation === "no_recomendable"}
                onChange={handleRadioChange}
                disabled={true}
              />
              NO RECOMENDABLE
            </label>
          </div>
          {/* Imagen de Semaforo */}
          <img src={selectedImage} alt="Semaforo" className="w-70 h-70" />
        </div>
      </div>

      <div className="grid grid-cols-3 gap-4">
        {/* Campo para RFC */}
        <div className="col-span-1">
          <Label htmlFor="rfc">RFC:</Label>
          <TextInput
            id="rfc"
            name="rfc"
            onChange={handleInputChange}
            value={queryEvaluado.data?.rfc || ""}
            disabled={true}
          />
        </div>
        {/* Edad */}
        <div className="col-span-1">
          <Label htmlFor="edad">EDAD:</Label>
          <TextInput
            id="edad"
            name="edad"
            value={edad !== null ? edad.toString() : ""}
            disabled={true}
          />
        </div>
        {/* Género */}
        <div className="col-span-1">
          <Label htmlFor="sexo">SEXO:</Label>
          <TextInput
            id="sexo"
            name="sexo"
            onChange={handleInputChange}
            value={queryEvaluado.data?.genero || ""}
            disabled={true}
          />
        </div>
        {/* Estado Civil */}
        <div className="col-span-1">
          <Label htmlFor="estadoCivil">ESTADO CIVIL:</Label>
          <TextInput
            id="estadoCivil"
            name="estadoCivil"
            onChange={handleInputChange}
            value={queryEvaluado.data?.estado_civil || ""}
            disabled={true}
          />
        </div>
        {/* Escolaridad */}
        <div className="col-span-1">
          <Label htmlFor="escolaridad">ESCOLARIDAD:</Label>
          <TextInput
            id="escolaridad"
            name="escolaridad"
            onChange={handleInputChange}
            value={queryEvaluado.data?.escolaridad || ""}
            disabled={true}
          />
        </div>
        {/* Fecha de Nacimiento */}
        <div className="col-span-1 flex items-center">
          <Label htmlFor="fechaNacimiento" className="mr-2">
            FECHA DE NACIMIENTO:
          </Label>
          <TextInput
            id="fechaNacimiento"
            name="fechaNacimiento"
            value={queryEvaluado.data?.fecha_nacimiento || ""}
            disabled={true}
            type="date"
            className="w-32"
          />
        </div>
        {/* CURP */}
        <div className="col-span-1">
          <Label htmlFor="curp">CURP:</Label>
          <TextInput
            id="curp"
            name="curp"
            onChange={handleInputChange}
            value={queryEvaluado.data?.curp || ""}
            disabled={true}
          />
        </div>
        {/* Empresa */}
        <div className="col-span-1">
          <Label htmlFor="empresa">EMPRESA:</Label>
          <TextInput
            id="empresa_id"
            name="empresa"
            value={queryEvaluado.data?.empresa_id?.nombre || ""}
            onChange={handleInputChange}
            disabled={true}
          />
        </div>
        {/* Motivo de la evaluación */}
        <div className="col-span-1">
          <Label htmlFor="motivo_evaluacion">MOTIVO DE LA EVALUACIÓN:</Label>
          <TextInput
            id="motivo_evaluacion"
            type="text"
            value={queryEvaluado.data?.motivo_evaluacion || ""}
            className="w-full"
            disabled={true}
          />
        </div>

        <div className="col-span-1">
          <Label htmlFor="tipo_evaluacion">TIPO:</Label>
          <TextInput
            id="tipo_evaluacion"
            type="text"
            value={queryEvaluado.data?.tipo_evaluacion || ""}
            className="w-full"
            disabled={true}
          />
        </div>
      </div>
    </div>
  );

  const renderPage2 = () => (
    <div className={`space-y-6 p-6 rounded-lg shadow-md ${isDarkMode ? "bg-gray-900 text-white" : "bg-gray-50"}`}>
      <div className={`p-4 rounded-lg shadow ${isDarkMode ? "bg-blue-900 text-white" : "bg-customBlue text-white"}`}>
        <h2 className="font-bold text-xl">RESULTADO GENERAL</h2>
      </div>

      <div className={`flex flex-col items-center border-dashed border-4 rounded-lg p-8 space-y-4 relative ${isDarkMode ? "border-gray-600 bg-gray-800" : "border-gray-300 bg-gray-100"}`}>
        <div className="w-full mt-4">
          <span className={`mb-2 text-justify block ${isDarkMode ? "text-gray-200" : "text-gray-900"}`}>
            Del contenido de las conclusiones que emite cada área de evaluación,
            se realizó una valoración, análisis y revisión con la finalidad de
            identificar los riesgos en conjunto, dado lo anterior se encontró lo
            siguiente en el proceso de evaluación.
          </span>
          <span className={`mb-2 text-justify block ${isDarkMode ? "text-gray-200" : "text-gray-900"}`}>
            Se considera que es una{" "}
            <strong>
              PERSONA{" "}
              <span className={isDarkMode ? "text-gray-200" : "text-gray-900"}>
                {selectedRecommendation === "recomendable"
                  ? "RECOMENDABLE"
                  : selectedRecommendation === "con_reserva"
                  ? "CON RESERVA"
                  : selectedRecommendation === "no_recomendable"
                  ? "NO RECOMENDABLE"
                  : ""}
              </span>
            </strong>
            , en virtud de que al momento de{" "}
            <strong>
              {" "}
              {queryResultadosRFP.data && queryResultadosRFP.data.length > 0
                ? queryResultadosRFP.data[0]?.evaluacion_2rfp || ""
                : ""}{" "}
            </strong>{" "}
          </span>
          <span className={`mt-2 mb-2 text-left font-semibold text-lg block ${isDarkMode ? "text-blue-400" : "text-blue-600"}`}>
            RECOMENDACIÓN
          </span>
          <span className={`mt-2 mb-2 text-left font-medium text-base block ${isDarkMode ? "text-blue-300" : "text-blue-500"}`}>
            CON LA FINALIDAD DE APOYAR Y FORTALECER LA SEGURIDAD DE LAS EMPRESAS
            SE SUGIERE:
          </span>
          <label
            htmlFor="nombre"
            className={`font-normal inline-block text-justify ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}
          >
            {queryNotasRFP.data && queryNotasRFP.data.length > 0
              ? (queryNotasRFP.data[0]?.nota_3rfp || "")
                  .split("\n")
                  .map((paragraph, index) => (
                    <p key={index} className="mb-2">
                      {" "}
                      {paragraph}
                    </p>
                  ))
              : ""}
          </label>
        </div>
      </div>
    </div>
  );

  return (
    <div className={`min-h-screen ${isDarkMode ? "bg-gray-900" : "bg-gray-50"}`}>
      <div className="container mx-auto p-4">
        <form
          className={`max-w-4xl mx-auto rounded-lg shadow-lg overflow-hidden ${isDarkMode ? "bg-gray-800" : "bg-white"}`}
          onSubmit={handleSubmit}
        >
          {renderHeader()}

          {currentPage === 1 && renderPage1()}
          {currentPage === 2 && renderPage2()}

          <div className="mt-6 p-4 flex justify-between">
            {/* Botón Cancelar en renderPage1 (lado izquierdo) */}
            {currentPage === 1 && (
              <Button
                onClick={() => {
                  window.scrollTo(0, 0);
                  navigate(`/evaluaciones/presencial/reporte-final/${evaluadosList_id}`);
                }}
                className={`ml-2 ${isDarkMode ? "bg-red-700 hover:bg-red-800 text-white" : "bg-red-500 hover:bg-red-600 text-white"}`}
              >
                Cancelar
              </Button>
            )}

            {currentPage > 1 && (
              <Button
                onClick={() => {
                  handlePageChange(currentPage - 1);
                  window.scrollTo(0, 0);
                }}
                className={`ml-2 ${isDarkMode ? "bg-violet-700 hover:bg-violet-800 text-white" : "bg-violet-500 hover:bg-violet-600 text-white"}`}
              >
                Anterior
              </Button>
            )}

            {/* Botón Siguiente en renderPage1 (lado derecho) */}
            {currentPage < 2 && (
              <Button
                className={`ml-2 ${isDarkMode ? "bg-blue-700 hover:bg-blue-800 text-white" : "bg-blue-500 hover:bg-blue-600 text-white"}`}
                onClick={() => {
                  handlePageChange(currentPage + 1);
                  window.scrollTo(0, 0);
                }}
              >
                Siguiente
              </Button>
            )}

            {/* Botón Guardar */}
            {currentPage === 2 && (
              <div className="flex space-x-4">
                <Button 
                  onClick={handlePrint}
                  className={`ml-2 ${isDarkMode ? "bg-blue-700 hover:bg-blue-800 text-white" : "bg-blue-500 hover:bg-blue-600 text-white"}`}
                >
                  Imprimir
                </Button>
                <Button
                  className={`ml-2 ${isDarkMode ? "bg-red-700 hover:bg-red-800 text-white" : "bg-red-500 hover:bg-red-600 text-white"}`}
                  onClick={() => {
                    window.scrollTo(0, 0);
                    navigate(`/evaluaciones/presencial/reporte-final/${evaluadosList_id}`);
                  }}
                >
                  Salir
                </Button>
              </div>
            )}
          </div>

          {/* Sección de Certificación */}
          {currentPage === 2 && evaluadosList_id && (
            <div className={`mt-6 p-4 border-t ${isDarkMode ? "border-gray-700" : "border-gray-200"}`}>
              <CertificacionQR
                evaluadoId={evaluadosList_id}
                nombreEvaluado={`${queryEvaluado.data?.nombre || ""} ${queryEvaluado.data?.apellido_paterno || ""} ${queryEvaluado.data?.apellido_materno || ""}`}
                tipoEvaluacion="presencial"
                autoGenerate={true}
                className="mb-4"
              />
            </div>
          )}
        </form>
        {/* Imprimir */}
        <div id="printableContent" style={{ display: "none" }}>
          <ReporteFinalPresencialPrint />
        </div>
      </div>
    </div>
  );
};
